import notification from "@repositories/notification";
import { NotificationsPaginationQueryOptionsType, QueryOptionsType } from "@ts-types/custom.types";
import { NotificationCount } from "@ts-types/generated";
import { API_ENDPOINTS } from "@utils/api/endpoints";
import { mapPaginatorData } from "@utils/data-mappers";
import { useMutation, useQuery } from "react-query";

export const fetchNotificationCount = async () => {
  const { data } = await notification.find(`${API_ENDPOINTS.TOTAL_COUNT_HEADER}`);
  return data.notifications;
};

export const useNotificationCountQuery = ( options: any = {}) => {
  return useQuery<NotificationCount, Error>([`${API_ENDPOINTS.TOTAL_COUNT_HEADER}`], () =>
    fetchNotificationCount(), {
      staleTime: Infinity,
      ...options
    }
  );
};

export const fetchAllNotifications = async ({ queryKey }: any) => {
  const [_key, params] = queryKey;
  const {
    limit = 15,
    type,
    locale,
    page
  } = params as any;

  const url = `${API_ENDPOINTS.NOTIFICATIONS}?limit=${limit || ""}&type=${type || ""}&page=${page || 1}&local=${locale}`;
  const {
    data: { data, ...rest },
  } = await notification.all(url);
  const paginatorInfo = mapPaginatorData({ ...rest }) as any;
  if (rest && rest.unread_count !== undefined) {
    paginatorInfo.unreadCount = rest.unread_count;
  }
  if (rest && rest.total_count !== undefined) {
    paginatorInfo.totalCount = rest.total_count;
  }
  return { notifications: { data, paginatorInfo } };
};

export const useAllNotificationQuery = (params: QueryOptionsType = {}, options: any = {}) => {
  return useQuery<any, Error>([API_ENDPOINTS.NOTIFICATIONS, params], fetchAllNotifications, {
    ...options,
    staleTime: Infinity
  });
};


export const fetchLastestNotifications = async (params: NotificationsPaginationQueryOptionsType) => {
  const {
    limit,
    locale
  } = params as any;

  const url = `${API_ENDPOINTS.LASTEST_NOTIFICATION}?limit=${limit || ""}&local=${locale}`;
  const {
    data: { data, ...rest },
  } = await notification.all(url);

  return { notifications: data, paginatorInfo: mapPaginatorData({ ...rest })};
}

export const useLastestNotificationsQuery = (
  params: NotificationsPaginationQueryOptionsType,
  options?: any
) => {
  return useQuery<any, Error>([API_ENDPOINTS.LASTEST_NOTIFICATION, params], () =>
    fetchLastestNotifications(params), {
      staleTime: Infinity,
      ...options
    }
  );
};

export const useReadNotificationMutation = () => {
  return useMutation((input: { notification_id: number | string }) => notification.create(API_ENDPOINTS.READ_NOTIFICATION, input as any));
}

export const useReadAllNotificationMutation = () => {
  return useMutation(() => notification.create(API_ENDPOINTS.READ_ALL_NOTIFICATION, {}));
}

export const useDeleteAllNotificationMutation = () => {
  return useMutation(() => notification.delete(API_ENDPOINTS.DELETE_ALL_NOTIFICATION,'' ,{}));
}

export const useDeleteNotificationMutation = () => {
  return useMutation((input: { notification_id: number | string }) => notification.delete(API_ENDPOINTS.DELETE_NOTIFICATION ,'', input as any));
}

export const fetchNotificationReadIds = async () => {
  const response = await notification.all(API_ENDPOINTS.NOTIFICATION_READ_IDS);

  return response.data
}

export const useNotificationReadIdsQuery = (
  options?: any
) => {
  return useQuery<any, Error>(API_ENDPOINTS.NOTIFICATION_READ_IDS, () =>
    fetchNotificationReadIds(), { ...options, staleTime: Infinity }
  );
};